// 汎用データ格納クラス
export class DataContainer
{
    // コンバート済みPNGイメージマップ
    // SVG -> PNGされたものをidと保持する
    private _convertedImageMap : { [ id : string ] : string } = {};

    public addConvertedImage(id : string, image : string)
    {
        this._convertedImageMap[id] = image;
    }

    public getConvertedImageKeys()
    {
        return Object.keys(this._convertedImageMap);
    }

    public getConvertedImage(id : string)
    {
        return this._convertedImageMap[id];
    }

    public deleteConvertedImage(id : string)
    {
        if(this._convertedImageMap[id])
        {
            delete this._convertedImageMap[id];
        }
    }
}